import React, {useState} from 'react'
import '../styles/mobile-menu.css'
import {Link} from 'gatsby'
import {Button} from 'react-bootstrap'
import Menus from './Menus'

const MobileMenu = (props) => {

  let attachedClasses = ['mobnavbar', 'close'];
  let overlayClasses = ['mobnavoverlay', 'close'];


  if(props.open)
  {
      attachedClasses = ['mobnavbar', 'open'];
      overlayClasses = ['mobnavoverlay', 'open'];
  }

  const [current, setCurrent] = useState({
    isProduct: false,
    isService: false,
    isResource: false,
  })

  const enableTab = val => {

    let product = false;
    let service = false;
    let resource = false;

    switch (val)
    {
        case "product":
        product = true;
        break;
        case "service":
        service = true;
        break;
        case "resource":
        resource = true;
        break;

        default:
        break;
    }

    setCurrent((prevState) => {
      return { ...prevState, isProduct: product, isService: service, isResource: resource};
     });

}

  

  return(
    <div>
      <div className={attachedClasses.join(' ')}>
        <ul className="navbar-nav mobnav">
          <Menus /> 
        </ul>
      </div>
      <div role="button" tabIndex="0" aria-label="overlay" className={overlayClasses.join(' ')} onClick={props.close} onKeyDown={props.close}></div>
    </div>
  )
}

export default MobileMenu
